<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    switchFullscreen
    :fullscreen="true"
    @ok="myHandleOk"
    @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">
        <a-row>
          <a-col :xs="24" :sm="12">
            <a-form-item label="门店编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['phystoreCode', validatorRules.phystoreCode]"
                       placeholder="请输入门店编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="门店名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phystoreName', validatorRules.phystoreName]" placeholder="请输入门店名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="门店地址" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-textarea v-decorator="['phystoreAddress', validatorRules.phystoreAddress]" rows="4"
                          placeholder="请输入门店地址"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['isEnabled', validatorRules.isEnabled]"
                                 :trigger-change="true" dictCode="yn" placeholder="请选择是否启用"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="门店地图坐标" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phystoreCoordinate', validatorRules.phystoreCoordinate]"
                       placeholder="请输入门店地图坐标"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="24">
            <a-form-item label="门店负责人" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                         :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}">
              <j-select-user-by-dep  v-decorator="['phystoreOwner', validatorRules.phystoreOwner]"
                                    :trigger-change="true" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="24">
            <a-form-item label="门店员工" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                         :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}">
              <j-select-user-by-dep v-decorator="['phystoreMembers']" :trigger-change="true"/>
            </a-form-item>
          </a-col>
          <!--          <a-col :xs="24" :sm="12">-->
          <!--            <a-form-item label="门店后场打印机" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--              <a-input v-decorator="['phystoreBackendPrinter']" placeholder="请输入门店后场打印机"></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :xs="24" :sm="12">-->
          <!--            <a-form-item label="门店前场打印机" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--              <a-input v-decorator="['phystoreFrontendPrinter']" placeholder="请输入门店前场打印机"></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :xs="24" :sm="12">
            <a-form-item label="门店联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phystoreContact']" placeholder="请输入门店联系电话"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item label="关联总仓" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-multi-select-tag type="list_multi"
                                  v-decorator="['phystoreWarehouse',validatorRules.phystoreWarehouse]"
                                  :trigger-change="true" dictCode="bas_warehouse,name,id,pid=0"
                                  placeholder="请选择关联总仓"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="闪送账号" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-textarea v-decorator="['ishansongAccountInfo']" rows="4"
                          placeholder="闪送账号"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="饿了么账号" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-textarea v-decorator="['elemeAccountInfo']" rows="4"
                          placeholder="饿了么账号"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="美团账号" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-textarea v-decorator="['meituanAccountInfo']" rows="4"
                          placeholder="美团账号"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="票点点账号" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-textarea v-decorator="['pddAccountInfo']" rows="4"
                          placeholder="票点点账号"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="门店经营主体信息" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <a-textarea v-decorator="['companyInfo']" rows="4"
                          placeholder="门店经营主体信息"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="门店与渠道门店关系附表" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="salesStoreOnlineidTable.loading"
            :columns="salesStoreOnlineidTable.columns"
            :dataSource="salesStoreOnlineidTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true"/>
        </a-tab-pane>

      </a-tabs>

    </a-spin>
  </j-modal>
</template>

<script>

  import pick from 'lodash.pick'
  import {FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormAndTables} from '@/utils/JEditableTableUtil'
  import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'
  import {validateDuplicateValue} from '@/utils/util'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import {putAction} from "@/api/manage";
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"

  export default {
    name: 'SalesPhysicalStoreModal',
    mixins: [JEditableTableMixin],
    components: {
      JSelectUserByDep,
      JMultiSelectTag
    },
    data() {
      return {
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        labelCol2: {
          xs: {span: 24},
          sm: {span: 3},
        },
        wrapperCol2: {
          xs: {span: 24},
          sm: {span: 20},
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          phystoreCode: {
            rules: [
              {required: true, message: '请输入门店编号!'},
            ]
          },
          phystoreName: {
            rules: [
              {required: true, message: '请输入门店名称!'},
            ]
          },
          phystoreAddress: {
            rules: [
              {required: true, message: '请输入门店地址!'},
            ]
          },
          phystoreCoordinate: {
            rules: [
              {required: true, message: '请输入门店地图坐标!'},
            ]
          },
          phystoreOwner: {
            rules: [
              {required: true, message: '请输入门店负责人!'},
            ]
          },
          phystoreMembers: {
            rules: [
              {required: true, message: '请输入门店员工!'},
            ]
          },
          phystoreWarehouse: {
            rules: [
              {required: true, message: '请选择关联总仓!'},
            ]
          },
          isEnabled: {
            rules: [
              {required: true, message: '请选择关联总仓!'},
            ]
          }
        },
        refKeys: ['salesStoreOnlineid',],
        tableKeys: ['salesStoreOnlineid',],
        activeKey: 'salesStoreOnlineid',
        // 门店与渠道门店关系附表
        salesStoreOnlineidTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '线上渠道编码',
              key: 'channelCode',
              type: FormTypes.select,
              dictCode: "sales_channel,channel_name,channel_code",
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '线上渠道门店id',
              key: 'channelStoreId',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          add: "/sales/salesPhysicalStore/add",
          edit: "/sales/salesPhysicalStore/edit",
          salesStoreOnlineid: {
            list: '/sales/salesPhysicalStore/querySalesStoreOnlineidByMainId'
          },
        }
      }
    },
    methods: {
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        this.salesStoreOnlineidTable.dataSource = [];
        let fieldval = pick(this.model, 'phystoreCode', 'phystoreName', 'phystoreAddress', 'phystoreCoordinate', 'phystoreMembers', 'phystoreOwner', 'phystoreBackendPrinter', 'phystoreFrontendPrinter', 'phystoreContact', 'phystoreWarehouse', 'isEnabled','ishansongAccountInfo','elemeAccountInfo','meituanAccountInfo','pddAccountInfo','companyInfo')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        if (!this.model.phystoreCode) {
          this.generateStoreCode()
        }
        // 加载子表数据
        if (this.model.id) {
          let params = {id: this.model.id}
          this.requestSubTableData(this.url.salesStoreOnlineid.list, params, this.salesStoreOnlineidTable)
        }
      },
      generateStoreCode() {
        const url = '/sys/fillRule/executeRuleByCode/'
        const ruleCode = 'store_code'
        putAction(url + ruleCode, {}).then(res => {
          if (res.success) {
            this.$nextTick(() => {
              this.form.setFieldsValue({'phystoreCode': res.result})
            })
          }
        })
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          salesStoreOnlineidList: allValues.tablesValue[0].values,
        }
      },
      validateError(msg) {
        this.$message.error(msg)
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'phystoreCode', 'phystoreName', 'phystoreAddress', 'phystoreCoordinate', 'phystoreMembers', 'phystoreOwner', 'phystoreBackendPrinter', 'phystoreFrontendPrinter', 'phystoreContact', 'phystoreWarehouse', 'isEnabled'))
      },
      myHandleOk(){
        /** 触发表单验证 */
        this.getAllTable().then(tables => {
          /** 一次性验证主表和所有的次表 */
          return validateFormAndTables(this.form, tables)
        }).then(allValues => {
          if (typeof this.classifyIntoFormData !== 'function') {
            throw this.throwNotFunction('classifyIntoFormData')
          }
          let formData = this.classifyIntoFormData(allValues)
          // 发起请求
          /* if(formData.phystoreMembers.indexOf(formData.phystoreOwner)<0){
            formData.phystoreMembers = formData.phystoreMembers + ',' + formData.phystoreOwner
          } */
          return this.request(formData)
        }).catch(e => {
          if (e.error === VALIDATE_NO_PASSED) {
            // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
            this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
          } else {
            console.error(e)
          }
        })
      }
    }
  }
</script>

<style scoped>
</style>